export const bettingTypeShortNames: Record<string, string> = {
    "1": 'G',
    "2": 'P',
    "4": 'GP',
    "8": 'Io',
    "10": 'I',
    "14": 'Ç',
    "15": '3G',
    "16": '4G',
    "17": '5G',
    "18": '6G',
    "47": 'Pl',
    "51": 'U',
    "61": '5B',
    "54": 'T',
};
